/**
 * uploadHallazgoFotos — lógica de subida de fotos por hallazgo extraída de doPost.
 *
 * Itera sobre hallazgosOrden en el mismo orden enviado al backend y llama
 * `ref.uploadPending(hallazgosCreados[i].id)` sobre el ref correspondiente al _key
 * de cada hallazgo (con fallback al índice cuando no hay _key).
 *
 * Tolerancia a fallos: si un ref lanza, se invoca onError(i, err) y se continúa
 * con los demás — el fallo de una foto no aborta las siguientes.
 *
 * @param {Array}   hallazgosOrden   - Hallazgos en el orden enviado al backend (con _key).
 * @param {Array}   hallazgosCreados - Respuesta del backend: hallazgos[].{id, ...} en mismo orden.
 * @param {Map}     fotosRefsMap     - Map de _key → ref ({ hasPending(), uploadPending(id) }).
 * @param {Object}  [options]
 * @param {Function} [options.onError] - Callback (index, err) llamado por cada fallo (opcional).
 * @returns {Promise<number>} Número de fallos encontrados.
 */
export async function uploadHallazgoFotos(
  hallazgosOrden,
  hallazgosCreados,
  fotosRefsMap,
  { onError } = {}
) {
  if (!Array.isArray(hallazgosCreados) || hallazgosCreados.length === 0) return 0;

  let fallos = 0;
  for (let i = 0; i < hallazgosOrden.length; i++) {
    const key = hallazgosOrden[i]._key ?? i;
    const ref = fotosRefsMap.get(key);
    const idHallazgo = hallazgosCreados[i]?.id;
    if (ref && idHallazgo && ref.hasPending()) {
      try {
        // eslint-disable-next-line no-await-in-loop
        await ref.uploadPending(idHallazgo);
      } catch (err) {
        fallos += 1;
        onError?.(i, err);
      }
    }
  }
  return fallos;
}
